/*                                                                                             */
/*                                                           */
export var is_array = Array.isArray;
export var index_of = Array.prototype.indexOf;
export var includes = Array.prototype.includes;
export var array_from = Array.from;
export var object_keys = Object.keys;
export var define_property = Object.defineProperty;
export var get_descriptor = Object.getOwnPropertyDescriptor;
export var get_descriptors = Object.getOwnPropertyDescriptors;
export var object_prototype = Object.prototype;
export var array_prototype = Array.prototype;
export var get_prototype_of = Object.getPrototypeOf;
export var is_extensible = Object.isExtensible;
export var has_own_property = Object.prototype.hasOwnProperty;

/**
 *
 *
 */
export function is_function(thing) {
	return typeof thing === 'function';
}

export const noop = () => {};

/*                                                                   */
/*                                                                                   */

/**
 *
 *
 *
 */
export function is_promise(value) {
	return typeof value?.then === 'function';
}

/*                       */
export function run(fn) {
	return fn();
}

/*                                 */
export function run_all(arr) {
	for (var i = 0; i < arr.length; i++) {
		arr[i]();
	}
}

/**
 *
 *
 */
export function deferred() {
	/*                             */
	var resolve;

	/*                                */
	var reject;

	/*                     */
	var promise = new Promise((res, rej) => {
		resolve = res;
		reject = rej;
	});

	/*               */
	return { promise, resolve, reject };
}

/**
 *
 *
 *
 *
 *
 */
export function fallback(value, fallback, lazy = false) {
	return value === undefined
		? lazy
			? /*                  */ (fallback)()
			: /*            */ (fallback)
		: value;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function to_array(value, n) {
	/*                      */
	if (Array.isArray(value)) {
		return value;
	}

	/*                                                                */
	/*                                                                  */
	/*                                    */
	if (n === undefined || !(Symbol.iterator in value)) {
		return Array.from(value);
	}

	/*                                           */

	/*              */
	const array = [];

	for (const element of value) {
		array.push(element);
		if (array.length === n) break;
	}

	return array;
}

/**
 *
 *
 *
 */
export function exclude_from_object(obj, keys) {
	/*                                           */
	var result = {};

	for (var key in obj) {
		if (!keys.includes(key)) {
			result[key] = obj[key];
		}
	}

	for (var symbol of Object.getOwnPropertySymbols(obj)) {
		if (Object.propertyIsEnumerable.call(obj, symbol) && !keys.includes(symbol)) {
			result[symbol] = obj[symbol];
		}
	}

	return result;
}
